import CollapsingHeader from './CollapsingHeader/CollapsingHeader';
import NumberField from './NumberFields/NumberFields';
import styles from './SizeAndWeightStyles.module.css';

const BridgeFormulaDistance = ({ bridgeFormulaDistances, dispatch, handleChange, disabled, nightMode }) => {
  const { outerDimension, innerDimension, triaxleDimension } = bridgeFormulaDistances;
  return (
    <CollapsingHeader nightMode={nightMode} title={"Bridge Formula Distance"} defaultOpen={true}>
      <div className={styles['flexRow']}>
        <NumberField
          maxLength={3}
          label={"Outer"}
          value={outerDimension}
          dispatch={dispatch}
          handleBlur={handleChange}
          action={'UPDATE_PROPERTY'}
          property={'outerDimension'}
          ft={true}
          disabled={disabled}
        />
        <NumberField
          maxLength={3}
          label={"Inner"}
          value={innerDimension}
          dispatch={dispatch}
          handleBlur={handleChange}
          action={'UPDATE_PROPERTY'}
          property={'innerDimension'}
          ft={true}
          disabled={disabled}
        />
        <NumberField
          maxLength={3}
          label={"Triaxle"}
          value={triaxleDimension}
          dispatch={dispatch}
          handleBlur={handleChange}
          action={'UPDATE_PROPERTY'}
          property={'triaxleDimension'}
          ft={true}
          disabled={disabled}
        />
      </div>
    </CollapsingHeader>
  );
}

export default BridgeFormulaDistance;